<template>
  <div
    v-if="hasItems"
    class="sidebar-menu space-y-4 overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-transparent dark:[&::-webkit-scrollbar-thumb]:bg-gray-700"
    :style="{ height: `${menuHeight}px` }"
    dusk="sidebar-menu"
    role="navigation"
    dir="ltr"
  >
    <component
      :key="item.key"
      :is="item.component"
      v-for="(item, index) in mainMenu"
      :dir="isRTL ? 'rtl' : 'ltr'"
      :item="item"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenu',

  props: {
    menuHeight: {
      type: Number,
      default: 600,
    },
  },

  computed: {
    ...mapGetters(['mainMenu']),

    isRTL() {
      return Nova.config('rtlEnabled')
    },

    hasItems() {
      return this.mainMenu.length > 0
    },
  },
}
</script>